import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import { Box, Typography, Divider, Chip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import frLocale from "date-fns/locale/fr";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import BadgeIcon from "@mui/icons-material/Badge";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { styled } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { API } from "../../../api/API";
import RenderContent from "../RenderModuleContent";

const StatusChip = styled(Chip)(({ theme, active }) => ({
  backgroundColor: active
    ? theme.palette.success.light
    : theme.palette.error.light,
  color: active ? theme.palette.success.dark : theme.palette.error.dark,
  fontWeight: 600,
}));

const InfoRow = ({ icon, label, value }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
    <Box sx={{ mr: 2, color: "text.secondary" }}>{icon}</Box>
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1">{value || "Non renseigné"}</Typography>
    </Box>
  </Box>
);
const ModuleView = ({ module }) => {
  if (!module) return null;

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",

        p: 2,
        mb: 2,
        boxShadow: 1,
        backgroundColor: "background.paper",
        width: "100%", // Ensure it takes the full width
        marginBottom: "0px", // Add margin between components
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {module.label}:{module.description}
      </Typography>
      {module.content && RenderContent(module.content)}
    </Box>
  );
};
const VuePolice = ({ show, handleClose, police }) => {
  const [policeDetails, setPoliceDetails] = useState(null);

  useEffect(() => {
    if (police && police.id) {
      const fetchPoliceDetails = async () => {
        try {
          const response = await API.get(`/polices/${police.id}/details`);
          //  console.log("Police details:", response.data);
          const { police: police_ } = response.data;
          setPoliceDetails(police_);
        } catch (error) {
          console.error("Error fetching police details:", error);
        }
      };
      fetchPoliceDetails();
    }
  }, [police]);

  if (!police) {
    return null;
  }

  const { numero, label, description } = policeDetails || police;
  return (
    <Modal
      size="xl"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      scrollable
      className="mt-4"
    >
      <Modal.Header closeButton>
        <Typography
          variant="h5"
          component="h2"
          color="success"
          sx={{
            fontWeight: 600,

            textAlign: "center",
            width: "100%",
          }}
        >
          Police N°{numero}
        </Typography>
      </Modal.Header>

      <Modal.Body>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            p: 2,
          }}
        >
          {/* Colonne de gauche - Infos principales */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "background.paper",
              p: 2,
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            <Typography
              variant="h6"
              color="success"
              sx={{ fontWeight: 600, mb: 2 }}
            >
              Informations principales
            </Typography>
            <InfoRow label="Numéro" value={numero || "Non renseigné"} />
            <InfoRow
              icon={<BadgeIcon />}
              label="Label"
              value={label || "Non renseigné"}
            />
            <InfoRow
              icon={<ContactMailIcon />}
              label="Description"
              value={description || "Aucune description disponible"}
            />
          </Box>

          {/* Colonne de droite - Modules */}
          <Box
            sx={{
              flex: 2,
              backgroundColor: "background.paper",
              p: 2,
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            <Typography
              variant="h6"
              color="success"
              sx={{ fontWeight: 600, mb: 2 }}
            >
              Modules associés
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {policeDetails?.module_police?.length > 0 ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {policeDetails.module_police.map((module) => (
                  <ModuleView key={module.id} module={module} />
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Aucun module associé.
              </Typography>
            )}
          </Box>
        </Box>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="contained"
          onClick={handleClose}
          color="success"
          sx={{
            "&:hover": { backgroundColor: "primary.success" },
            px: 4,
            py: 1,
            fontWeight: 600,
          }}
        >
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VuePolice;
